import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

// Comps
import Mask from '../Mask/Mask';

// Lib
import { CSSTransition } from 'react-transition-group';

// Utils
import helpers from 'frontend/js/helpers';

type Props = {
  isOpen: boolean;
  onClickMask: () => void;
  lockBody?: boolean;
  // Use to delay clearing data when isOpen is dependent on the data in addition to boolean state
  animationCompleteCallback?: () => void;
  children: React.ReactNode;
  contentClass?: string;
};

const Modal = ({
  isOpen,
  onClickMask,
  lockBody = false,
  animationCompleteCallback,
  children,
  contentClass
}: Props) => {
  useEffect(() => {
    if (!lockBody) return;

    helpers.toggleClass(document.body, 'no-scroll', isOpen);
  }, [isOpen]);

  const modalRef = useRef(null);

  // Render into body
  return createPortal(
    <div className='modal relative z-50'>
      <Mask
        isShow={isOpen}
        onClick={onClickMask}
      />
      <CSSTransition
        in={isOpen}
        classNames='modal'
        timeout={500}
        nodeRef={modalRef}
        appear={true}
        unmountOnExit
      >
        <div
          ref={modalRef}
          className={`modal__content fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[55] max-h-[90vh] overflow-auto ${contentClass}`}
        >
          {children}
        </div>
      </CSSTransition>
    </div>,
    document.body
  );
};

export default Modal;
